// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ParametersAll_default_wrapper__2AfVB","modal":"ParametersAll_default_modal__2qn9Q"};